import { useAppDispatch } from "../../../app/hooks";
import { useSelector } from "react-redux";
import { assertThumbnailUrl, LoadState } from "../../../redux/common";
import { retrieveStudentClassrooms, selectStudentClassrooms, studentClassroomsSlice } from "../../../redux/student/studentClassroomsSlice";
import PrizaAvatarGrid from "../../../features/base/grid/PrizaAvatarGrid";

interface ContentListProps {
    studentId: string;
    schoolId: string;
}

const StudentSchoolClassroomList = ({ studentId, schoolId }: ContentListProps) => {
  const dispatch = useAppDispatch();

  const studentClassrooms = useSelector(selectStudentClassrooms);
  const list = studentClassrooms.list;

  if(studentClassrooms.state.state == LoadState.Loaded &&
      ( studentClassrooms.studentId != studentId || studentClassrooms.schoolId != schoolId )
    ) {
    dispatch(studentClassroomsSlice.actions.clean());
  }
  if(studentClassrooms.state.state == LoadState.NotStarted) {
    dispatch(retrieveStudentClassrooms({ studentId: studentId, schoolId: schoolId}));
  }

  const mapped = list ? list.map((classroom) => {
    return {
      image: assertThumbnailUrl(classroom.url),
      title: classroom.name,
      subtitle: "Sala de Aula",
      item: classroom,
    };
  }) : [];

  return <>
    <PrizaAvatarGrid list={mapped}
      toolbar={{
        label: "Salas de Aula"
      }}
      state={studentClassrooms.state}
      retry={() => { dispatch(studentClassroomsSlice.actions.clean()); }}
      messages={{
        empty: "Nenhuma sala de aula associada a este aluno nesta escola.",
        error: "Erro ao carregar salas de aula."
      }}
    />
  </>;
  

};

export default StudentSchoolClassroomList;